import { Action } from 'redux';

import { ScheduleLinkedTask } from '~src/app/actions/AppActionTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { ISpaceItemDetailInfo } from '~src/ts/models/ISpaceItemDetailInfo';

export interface ScheduleLinkedTaskReduxAction extends Action {
    readonly flow: IContentInfo;
}

export function scheduleLinkedTaskAction(flow: IContentInfo | ISpaceItemDetailInfo<'flow'>): ScheduleLinkedTaskReduxAction {
  return {
    type: ScheduleLinkedTask,
    flow
  };
}
